module.exports = __webpack_public_path__ + "static/media/lowercase.fcb1996a.svg";